import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Services } from "../../service";

@Injectable({
  providedIn: 'root'
})

export class QuickSearchApis {
  constructor(private service: Services) { }

  getListData(urlParams = {}): Observable<any> {
    return this.service.getRequest(`common/quick-search`, urlParams);
  }
}

